import { GET_STUDENTINFO_START, GET_STUDENTINFO_SUCCESS, GET_STUDENTINFO_ERROR } from '../constants';
import fetchErrorHandler from '../services/fetchErrorHandler';
import { getCsrfToken } from '../utils/helpers';

const studentInfo = applicationId => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  dispatch({ type: GET_STUDENTINFO_START });

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/student-info/`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(data => {
      dispatch({
        type: GET_STUDENTINFO_SUCCESS,
        payload: {
          data,
        },
      });
    })
    .catch(error => {
      console.error('error', error);
      dispatch({
        type: GET_STUDENTINFO_ERROR,
        payload: {
          error,
        },
      });
    });
};

export { studentInfo as default };
